/* bloom-details.js — the delivery-details dialog, everywhere.
 *
 * One dialog (snippets/bloom-details-dialog.liquid, rendered from the cart
 * drawer so it exists on every page), three ways in:
 *
 *   pdp   product page trigger (#bl-details) → writes hidden inputs into the
 *         product form through BloomDelivery.setProp (one writer, as before)
 *   gate  "Add to cart" pressed while name/phone are missing → the dialog
 *         opens itself, and its save button becomes "Save & add to cart"
 *   cart  "Edit details" under a line in the drawer or on the cart page →
 *         rewrites that line's properties through /cart/change.js
 *
 * Property key names come from window.BloomDetailsKeys (bloom-details-keys
 * .liquid) — in the current locale when writing, in EVERY locale when reading
 * a line back, because a customer may add in one language and edit in another.
 *
 * Date and window are never owned here. On the product page they are read
 * through window.BloomDelivery; in the cart they are shown read-only with a
 * link to the bouquet page. Two date pickers is how the old build ended up
 * with five cut-off rules.
 */
(function () {
  var dlg = document.getElementById('bl-details-dialog');
  if (!dlg || dlg.dataset.blInit) return;

  var cfgEl = document.querySelector('[data-bl-details-config]');
  var C = { require: true, cardMax: 220, cartUrl: '/cart', t: {} };
  if (cfgEl) { try { C = JSON.parse(cfgEl.textContent); } catch (e) {} }
  var T = C.t || {};

  var KEYS = window.BloomDetailsKeys || {};
  var LANG = KEYS.__locale || (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
  var K = KEYS[LANG] || KEYS.en || KEYS.ro;
  if (!K) return;
  var SEP = KEYS.__sep || ' · ';
  var LOCALES = Object.keys(KEYS).filter(function (l) { return l.charAt(0) !== '_'; });

  dlg.dataset.blInit = '1';

  var STORE_KEY = 'bloom:details:v2';
  var FIELDS = ['recipient', 'phone', 'access', 'message'];
  var TOGGLES = ['call', 'reception', 'photo', 'anon'];

  var q = function (sel, root) { return (root || dlg).querySelector(sel); };
  var whenEl = q('[data-bl-when]'),
      changeBtn = q('[data-bl-change]'),
      changeCart = q('[data-bl-change-cart]'),
      gateEl = q('[data-bl-gate]'),
      errEl = q('[data-bl-err]'),
      saveBtn = q('[data-bl-save]'),
      closeBtn = q('[data-bl-close]'),
      counter = q('[data-bl-count]'),
      sigEl = q('[data-bl-sig]'),
      msgEl = q('[data-bl-field="message"]');

  var trigger = document.getElementById('bl-details'); // product page only
  var state = { mode: 'pdp', form: null, line: null, item: null, focus: null };
  /* The product-page answer lives here, not in the inputs: the same inputs are
   * reused to edit a cart line, so "what the customer entered for THIS bouquet"
   * must survive that. draft = typed but not yet saved (closed by accident). */
  var pdp = { data: null, draft: null };

  /* ---- fields ---------------------------------------------------------- */
  function field(n) { return q('[data-bl-field="' + n + '"]'); }
  function read() {
    var d = {};
    FIELDS.forEach(function (n) { var el = field(n); d[n] = el ? el.value.trim() : ''; });
    TOGGLES.forEach(function (n) { var el = field(n); d[n] = el ? !!el.checked : false; });
    return d;
  }
  function write(d) {
    FIELDS.forEach(function (n) { var el = field(n); if (el) el.value = (d && d[n]) || ''; });
    TOGGLES.forEach(function (n) { var el = field(n); if (el) el.checked = !!(d && d[n]); });
    paintCounter(); paintSig();
  }
  function hasAny(d) {
    return FIELDS.some(function (n) { return d[n]; }) || TOGGLES.some(function (n) { return d[n]; });
  }

  /* ---- persistence (product page only) ---------------------------------
   * sessionStorage, not local: the recipient's name and phone are someone
   * else's personal data and must not outlive the browsing session. */
  function persist(d) { try { sessionStorage.setItem(STORE_KEY, JSON.stringify(d)); } catch (e) {} }
  function restore() {
    try { var raw = sessionStorage.getItem(STORE_KEY); return raw ? JSON.parse(raw) : null; }
    catch (e) { return null; }
  }

  /* ---- property assembly ------------------------------------------------ */
  function optionList(d) {
    var out = [];
    if (d.call) out.push(K.opt.call);
    if (d.reception) out.push(K.opt.reception);
    if (d.photo) out.push(K.opt.photo);
    if (d.anon) out.push(K.opt.anon);
    return out.join(SEP);
  }
  function propsFor(d) {
    var p = {};
    p[K.recipient] = d.recipient;
    p[K.phone] = d.phone;
    p[K.access] = d.access;
    p[K.card] = d.message;
    p[K.options] = optionList(d);
    return p;
  }
  function applyToForm(d) {
    if (!window.BloomDelivery) return;
    var p = propsFor(d);
    Object.keys(p).forEach(function (k) { window.BloomDelivery.setProp('properties[' + k + ']', p[k]); });
  }

  /* ---- reading a cart line back, in any locale ------------------------- */
  function keyNames(fieldName) {
    var out = [];
    LOCALES.forEach(function (l) { if (KEYS[l] && KEYS[l][fieldName]) out.push(KEYS[l][fieldName]); });
    return out;
  }
  function pick(props, fieldName) {
    var names = keyNames(fieldName);
    for (var i = 0; i < names.length; i++) {
      if (props[names[i]] != null && props[names[i]] !== '') return props[names[i]];
    }
    return '';
  }
  function parseItem(item) {
    var p = item.properties || {};
    var d = {
      recipient: pick(p, 'recipient'), phone: pick(p, 'phone'),
      access: pick(p, 'access'), message: pick(p, 'card'),
      call: false, reception: false, photo: false, anon: false
    };
    var opts = pick(p, 'options');
    if (opts) {
      var parts = opts.split(SEP.trim()).map(function (s) { return s.trim(); });
      LOCALES.forEach(function (l) {
        var o = KEYS[l] && KEYS[l].opt; if (!o) return;
        TOGGLES.forEach(function (t) { if (o[t] && parts.indexOf(o[t]) !== -1) d[t] = true; });
      });
    }
    d._iso = p._delivery_iso || '';
    // The stored date label is in the language the line was ADDED in; the
    // hidden ISO lets the cart show it in the language being READ in.
    d._date = (d._iso && dateLabel(d._iso)) || pick(p, 'date') || d._iso;
    d._window = pick(p, 'window');
    return d;
  }
  function dateLabel(iso) {
    var dt = new Date(iso + 'T12:00:00Z');
    var opts = { weekday: 'long', day: 'numeric', month: 'long' };
    try { return new Intl.DateTimeFormat(LANG, opts).format(dt); }
    catch (e) { try { return new Intl.DateTimeFormat('en', opts).format(dt); } catch (e2) { return iso; } }
  }
  function hasDelivery(item) {
    var p = item.properties || {};
    return !!(p._delivery_iso || pick(p, 'date'));
  }

  /* ---- validation ------------------------------------------------------- */
  function validate(d) {
    if (!C.require) return null;
    var bad = [];
    if (!d.recipient) bad.push('recipient');
    if (!d.phone) bad.push('phone');
    if (bad.length) return { msg: T.err, fields: bad };
    var digits = d.phone.replace(/\D/g, '');
    if (digits.length < 8 || digits.length > 15) return { msg: T.errPhone, fields: ['phone'] };
    return null;
  }
  function showError(err) {
    FIELDS.forEach(function (n) { var el = field(n); if (el) el.classList.remove('is-invalid'); });
    if (!err) { errEl.hidden = true; errEl.textContent = ''; return; }
    errEl.textContent = err.msg || '';
    errEl.hidden = false;
    err.fields.forEach(function (n) { var el = field(n); if (el) el.classList.add('is-invalid'); });
    var first = field(err.fields[0]);
    if (first) first.focus();
  }

  /* ---- paint ------------------------------------------------------------ */
  function whenLabel() {
    if (state.mode === 'cart' && state.item) {
      var d = parseItem(state.item);
      return d._date ? (d._window ? d._date + SEP + d._window : d._date) : '—';
    }
    var s = window.BloomDelivery ? window.BloomDelivery.get() : null;
    return (s && s.date) ? s.dateLabel + SEP + s.slotLabel : '—';
  }
  function paintWhen() {
    whenEl.textContent = whenLabel();
    var cart = state.mode === 'cart';
    changeBtn.hidden = cart;
    changeCart.hidden = !cart;
    if (cart && state.item) changeCart.href = state.item.url || '#';
  }
  function paintCounter() {
    if (!counter || !msgEl) return;
    var max = +msgEl.maxLength > 0 ? +msgEl.maxLength : C.cardMax;
    var n = msgEl.value.length;
    counter.textContent = n + ' / ' + max;
    counter.classList.toggle('is-near', max - n <= 20);
  }
  function paintSig() {
    if (!sigEl) return;
    var anon = field('anon');
    sigEl.textContent = (anon && anon.checked) ? '— ' + (T.anon || '') : '';
  }
  function paintTrigger() {
    if (!trigger) return;
    var d = pdp.data || read();
    var sumWhen = trigger.querySelector('[data-bl-sum-when]'),
        sumWho = trigger.querySelector('[data-bl-sum-who]'),
        action = trigger.querySelector('[data-bl-action]'),
        badge = trigger.querySelector('[data-bl-badge]');
    var ok = !validate(d) && (d.recipient || d.phone);
    if (sumWhen) sumWhen.textContent = whenLabel();
    if (sumWho) {
      var bits = [];
      if (d.recipient) bits.push(d.recipient);
      if (d.phone) bits.push(d.phone);
      if (bits.length && d.message) bits.push(T.cartCard + ' ✓');
      sumWho.textContent = bits.length ? bits.join(SEP) : (trigger.dataset.missing || '');
      sumWho.classList.toggle('bl-det__val--empty', !bits.length);
    }
    if (action) action.textContent = ok ? (trigger.dataset.edit || '') : (trigger.dataset.open || '');
    trigger.classList.toggle('is-done', !!ok);
    if (badge) badge.hidden = !!ok || !C.require;
  }

  /* ---- open / close ----------------------------------------------------- */
  function open(opts) {
    state.mode = opts.mode || 'pdp';
    state.form = opts.form || null;
    state.line = opts.line || null;
    state.item = opts.item || null;

    if (state.mode === 'cart') write(parseItem(state.item));
    else write(pdp.draft || pdp.data || {});

    gateEl.hidden = state.mode !== 'gate';
    saveBtn.textContent = state.mode === 'gate' ? saveBtn.dataset.labelAdd : saveBtn.dataset.label;
    saveBtn.disabled = false;
    saveBtn.classList.remove('is-busy');
    showError(null);
    paintWhen(); paintCounter(); paintSig();

    if (dlg.showModal) { if (!dlg.open) dlg.showModal(); } else dlg.setAttribute('open', '');
    dlg.querySelector('.bl-dlg__body').scrollTop = 0;

    var target = null;
    if (opts.focus === 'card') target = msgEl;
    else if (state.mode !== 'cart') {
      var d = read();
      target = !d.recipient ? field('recipient') : (!d.phone ? field('phone') : null);
    }
    if (target && window.matchMedia('(min-width: 821px)').matches) {
      setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }, 60);
    }
  }
  function close() {
    if (state.mode !== 'cart') pdp.draft = read();
    if (dlg.close) { if (dlg.open) dlg.close(); } else dlg.removeAttribute('open');
  }

  /* ---- save ------------------------------------------------------------- */
  function flashSaved(then) {
    var label = saveBtn.textContent;
    saveBtn.textContent = T.saved || label;
    saveBtn.disabled = true;
    setTimeout(function () {
      saveBtn.textContent = label;
      saveBtn.disabled = false;
      close();
      if (then) then();
    }, 450);
  }

  function submitProductForm(f) {
    if (!f) return;
    f.dataset.blBypass = '1';
    var btn = f.querySelector('button[type="submit"][name="add"]') || f.querySelector('button[type="submit"]');
    if (f.requestSubmit) { try { f.requestSubmit(btn || undefined); return; } catch (e) {} }
    if (btn) btn.click(); else f.submit();
  }

  function saveToCart(d) {
    var item = state.item, line = state.line;
    if (!item || !line) return;
    var props = {};
    var old = item.properties || {};
    var known = [];
    ['recipient', 'phone', 'access', 'card', 'options'].forEach(function (f) { known = known.concat(keyNames(f)); });
    Object.keys(old).forEach(function (k) { if (known.indexOf(k) === -1) props[k] = old[k]; });
    var fresh = propsFor(d);
    Object.keys(fresh).forEach(function (k) { if (fresh[k]) props[k] = fresh[k]; });

    saveBtn.classList.add('is-busy'); saveBtn.disabled = true;
    fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: item.quantity, properties: props })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function () {
        flashSaved(function () {
          if (document.body.classList.contains('template-cart')) { location.reload(); return; }
          if (window.theme && theme.miniCart) { theme.miniCart.updateElements(); theme.miniCart.generateCart(); }
          else refresh();
          document.dispatchEvent(new CustomEvent('bloom:cart-details-change'));
        });
      })
      .catch(function () {
        saveBtn.classList.remove('is-busy'); saveBtn.disabled = false;
        showError({ msg: T.err, fields: [] });
      });
  }

  function onSave() {
    if (!dlg.open) return;
    var d = read();
    var err = validate(d);
    if (err) { showError(err); return; }
    showError(null);
    if (state.mode === 'cart') { saveToCart(d); return; }
    pdp.data = d; pdp.draft = null;
    applyToForm(d);
    persist(d);
    paintTrigger();
    var f = state.mode === 'gate' ? state.form : null;
    flashSaved(function () { if (f) submitProductForm(f); });
  }

  /* ---- events inside the dialog ----------------------------------------- */
  saveBtn.addEventListener('click', onSave);
  closeBtn.addEventListener('click', close);
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });

  if (msgEl) msgEl.addEventListener('input', function () {
    paintCounter();
    dlg.querySelectorAll('.bl-chip.is-on').forEach(function (c) { c.classList.remove('is-on'); });
  });
  var anonEl = field('anon');
  if (anonEl) anonEl.addEventListener('change', paintSig);

  dlg.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.matches('input[data-bl-field]')) {
      e.preventDefault(); onSave();
    }
  });

  changeBtn.addEventListener('click', function () {
    close();
    var picker = document.getElementById('bl-dt');
    if (!picker) return;
    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    picker.classList.add('bl-dt--flash');
    setTimeout(function () { picker.classList.remove('bl-dt--flash'); }, 1200);
  });

  // Occasion ideas: each chip cycles through its variants on repeat clicks.
  var ideaIdx = {};
  dlg.querySelectorAll('[data-bl-idea]').forEach(function (chip, i) {
    chip.addEventListener('click', function () {
      var msgs = chip.getAttribute('data-bl-idea').split('||');
      ideaIdx[i] = ideaIdx[i] == null ? 0 : (ideaIdx[i] + 1) % msgs.length;
      if (!msgEl) return;
      msgEl.value = msgs[ideaIdx[i]];
      paintCounter();
      dlg.querySelectorAll('.bl-chip').forEach(function (c) { c.classList.toggle('is-on', c === chip); });
      msgEl.focus({ preventScroll: true });
      try { msgEl.setSelectionRange(msgEl.value.length, msgEl.value.length); } catch (e) {}
    });
  });

  /* ---- product page ------------------------------------------------------ */
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  if (trigger) {
    pdp.data = restore();
    if (pdp.data) applyToForm(pdp.data);
    paintTrigger();
    trigger.querySelector('[data-bl-open]').addEventListener('click', function () { open({ mode: 'pdp' }); });
    /* bloom-datetime.js dispatches its first change event BEFORE it exposes
     * window.BloomDelivery (the export is the last statement of its IIFE), so
     * the first paint would read "—". Repaint on the next tick and again once
     * the document is ready; both are cheap. */
    document.addEventListener('bloom:delivery-change', function () {
      paintTrigger();
      if (dlg.open && state.mode !== 'cart') paintWhen();
      if (!window.BloomDelivery) setTimeout(paintTrigger, 0);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintTrigger);
    else setTimeout(paintTrigger, 0);
  }

  // Any other opener on the page (e.g. the "free card" teaser) — product page only.
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-bl-open-details]') : null;
    if (!b || !trigger) return;
    e.preventDefault();
    open({ mode: 'pdp', focus: b.getAttribute('data-bl-open-details') || null });
  });

  /* The gate. Capture phase, so it runs before the theme's AJAX handler. If
   * the date is missing, bloom-datetime.js owns that error — we step aside. */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!trigger || !f || !f.action || String(f.action).indexOf('/cart/add') === -1) return;
    if (f.dataset.blBypass) { delete f.dataset.blBypass; return; }
    if (!C.require) return;
    var s = window.BloomDelivery ? window.BloomDelivery.get() : null;
    if (s && !(s.date && s.slot)) return;
    var d = pdp.data || read();
    if (!validate(d)) { applyToForm(d); return; }
    e.preventDefault();
    e.stopPropagation();
    open({ mode: 'gate', form: f });
  }, true);

  /* ---- cart: decorate every line that carries a delivery -------------------- */
  var ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>';

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function detailsHTML(item, line, compact) {
    var d = parseItem(item);
    var complete = !validate(d);
    var h = '<div class="bl-cdet" data-bl-cdet>';
    if (!compact) {
      if (d._date) h += '<span class="bl-cdet__row">' + esc(d._date) + (d._window ? SEP + esc(d._window) : '') + '</span>';
      if (d.recipient || d.phone) h += '<span class="bl-cdet__row">' + esc([d.recipient, d.phone].filter(Boolean).join(SEP)) + '</span>';
      if (d.message) h += '<span class="bl-cdet__row bl-cdet__row--card"><b>' + esc(T.cartCard) + ':</b> “' + esc(d.message) + '”</span>';
    }
    if (!complete) h += '<span class="bl-cdet__row bl-cdet__row--missing">' + esc(T.cartAdd) + '</span>';
    h += '<button type="button" class="bl-cdet__edit' + (complete ? '' : ' bl-cdet__edit--add') + '" data-bl-edit-line="' + line + '">' +
         ICON + esc(complete ? T.cartEdit : T.cartAdd) + '</button>';
    h += '</div>';
    return h;
  }

  var lastCart = null;
  function decorate(cart) {
    lastCart = cart;
    if (!cart || !cart.items) return;
    // drawer: theme.js renders .mini-cart-item with a qty input carrying data-line
    document.querySelectorAll('.js-mini-cart-content .mini-cart-item').forEach(function (el) {
      var inp = el.querySelector('[data-line]');
      var line = inp ? +inp.getAttribute('data-line') : 0;
      var item = cart.items[line - 1];
      var old = el.querySelector('[data-bl-cdet]');
      if (old) old.parentNode.removeChild(old);
      if (!item || !hasDelivery(item)) return;
      var meta = el.querySelector('.mini-cart-meta') || el;
      meta.insertAdjacentHTML('beforeend', detailsHTML(item, line, false));
    });
    // cart page: Liquid renders a host per line
    document.querySelectorAll('[data-bl-cart-line]').forEach(function (host) {
      var line = +host.getAttribute('data-bl-cart-line');
      var item = cart.items[line - 1];
      host.innerHTML = (item && hasDelivery(item)) ? detailsHTML(item, line, true) : '';
    });
  }

  var inflight = false;
  function refresh() {
    if (inflight) return;
    inflight = true;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(decorate)
      .catch(function () {})
      .then(function () { inflight = false; });
  }

  var drawer = document.querySelector('.js-mini-cart-content');
  if (drawer) {
    var timer = null;
    new MutationObserver(function (muts) {
      // ignore our own insertions
      var own = muts.every(function (m) {
        return Array.prototype.every.call(m.addedNodes, function (n) { return n.nodeType === 1 && n.hasAttribute('data-bl-cdet'); }) &&
               Array.prototype.every.call(m.removedNodes, function (n) { return n.nodeType === 1 && n.hasAttribute('data-bl-cdet'); });
      });
      if (own) return;
      clearTimeout(timer);
      timer = setTimeout(refresh, 150);
    }).observe(drawer, { childList: true, subtree: true });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-toggle-cart')) setTimeout(refresh, 250);
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-bl-edit-line]') : null;
    if (!b) return;
    e.preventDefault();
    var line = +b.getAttribute('data-bl-edit-line');
    var go = function (cart) {
      var item = cart && cart.items && cart.items[line - 1];
      if (!item) return;
      open({ mode: 'cart', line: line, item: item });
    };
    // open at once from the last snapshot (no visible delay), then confirm
    // against the live cart in case a quantity changed meanwhile
    if (lastCart) go(lastCart);
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart && cart.items && cart.items[line - 1];
        if (!item) return;
        if (!lastCart) { go(cart); return; }
        state.item = item; lastCart = cart;
      })
      .catch(function () {});
  });

  if (drawer || document.querySelector('[data-bl-cart-line]')) refresh();

  window.BloomDetails = { open: open, close: close, refresh: refresh, parseItem: parseItem };
})();
